// extracted by mini-css-extract-plugin
export default {"comment":"BasicInput_comment__YaWee"};